<template>
  <div>
    <el-dialog :visible="visible" @close="dialogClose()" top="5vh" title="创建入库单" :destroy-on-close="true">
      <el-form label-position="left">
        <el-form-item label="客户子账号ID" required label-width="120px">
          <el-input :disabled="matched" maxlength='50' v-model="customerId" @keydown.native.enter="search"
            style="width:200px;margin-right:10px;"></el-input>
          <el-button type="primary" :disabled="matched" @click="search">查询</el-button>
          <el-button type="default" :disabled="!matched" @click="reset">重置</el-button>
        </el-form-item>
        <el-form-item label="客户名称" required label-width="120px"> {{ customer.unificationCustomerFullName }}</el-form-item>
        <el-form-item label="店铺ID" required label-width="120px"> {{ customer.shopId }}</el-form-item>
        <el-form-item label="店铺名称" required label-width="120px"> {{ customer.shopName }}</el-form-item>
        <el-form-item label="库存类型" required label-width="120px"> 
          <el-radio-group  v-model="skuType">
            <el-radio-button :label="0">线上商品</el-radio-button>
            <el-radio-button :label="1">OEM</el-radio-button>
            <el-radio-button :label="2">线下商品</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="文件上传" required label-width="120px">
          <div>
            <el-upload class="uploader" action="#" :before-upload="beforeUpload" :file-list="fileList" :multiple="false"
              style="float:left" :show-file-list="false">
              <el-button type="default">
                <i class="el-icon-plus avatar-uploader-icon" style="margin-right:10px"></i>点击上传
              </el-button>
            </el-upload>
            <a :href="url" style="margin-left:10px;">文件下载</a>
          </div>
          <div v-if="uploadData" style="margin:1px 0;">{{ uploadData.name }}</div>
        </el-form-item>
      </el-form>
      <div style="text-align:right">
        <el-button type="default" @click="dialogClose()">取消</el-button>
        <el-button type="primary" @click="ok" :disabled="!(matched && uploadData)">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { createManualInboundOrder, getCustomerByID } from '@/apis/inHouse'
export default {
  name: "InterBtnBox",
  data() {
    return {
      customerId: '',
      customer: {
        unificationCustomerFullName: '',
        shopId: '',
        shopName: '',
      },
      skuType: 0,
      matched: false,
      uploadData: null,
      url: 'https://static-s.theckb.com/BusinessMarket/wms/马帮商品手动入库模板.xls',
      // url: 'https://theckbstest-oss.theckbs.com/%E9%A9%AC%E5%B8%AEsku%E6%89%8B%E5%8A%A8%E5%85%A5%E5%BA%93%E6%A8%A1%E6%9D%BF.xls',
      fileList: []
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
  },
  methods: {
    search() {
      getCustomerByID({ customerId: this.customerId }).then(res => {
        if (res.data) {
          this.matched = true
          this.customer = {
            unificationCustomerFullName: res.data.unificationCustomerFullName,
            shopId: res.data.customerShopId,
            shopName: res.data.customerShopName,
          }
        }
      })
    },
    reset() {
      this.matched = false
      this.customerId = '',
        this.customer = {
          unificationCustomerFullName: '',
          shopId: '',
          shopName: '',
        }
    },
    beforeUpload(file) {
      this.uploadData = file
      return false
    },
    async ok() {
      let forms = new FormData();
      forms.append("skuType", this.skuType);
      forms.append("customerShopId", this.customer.shopId);
      forms.append("file", this.uploadData);
      await createManualInboundOrder(forms).then(res => {
        console.log(res)
        if (res.code == 0) {
          this.$message.success('成功')
          this.$emit('submit')
        }
      })
      this.uploadData = null
      this.reset()
    },
    dialogClose() {
      
      this.customerId = '',
      this.customer = {
        unificationCustomerFullName: '',
        shopId: '',
        shopName: '',
      },
      this.skuType = 0,
      this.matched = false,
      this.uploadData = null,
      this.fileList = []
      this.$emit('close')
    }
  },
};
</script>

<style scoped>
.dialogTitle {
  height: 60px;
  width: 100%;
  font-size: 20px;
  text-align: center;
  line-height: 60px;
  background-color: #00284d;
  color: #e8e8e8;
}
</style>
